import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Checkout/Payment/payment.container"
    ).then((module) => ({
        default: module.PaymentContainer
    }))
);
